import React from 'react';
import ProfilePostList from './ProfilePostList';

function MyPaid() {
    return (
        <ProfilePostList endpoint={"my-paid"} emptyText={"PIC한 게시물이 없습니다."}/>
    );
}

export default MyPaid;